import axiosInstance from "../utilities/axiosSetup";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// The call_logs_report row a submission depends on is created asynchronously
// (Zoom webhook -> queue -> DB insert) and can occasionally still be in
// flight when the form is submitted. Rather than surface that timing gap as
// a hard error, retry a couple of times before giving up.
const CALL_LOG_NOT_FOUND_RETRY_DELAYS_MS = [1000, 2000];

const isCallLogNotFoundError = (error) =>
  error?.response?.status === 409 &&
  error?.response?.data?.message === "CALL_LOG_NOT_FOUND";

const postWithCallLogRetry = async (url, formData, config) => {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await axiosInstance.post(url, formData, config);
    } catch (error) {
      if (!isCallLogNotFoundError(error) || attempt >= CALL_LOG_NOT_FOUND_RETRY_DELAYS_MS.length) {
        throw error;
      }
      await sleep(CALL_LOG_NOT_FOUND_RETRY_DELAYS_MS[attempt]);
    }
  }
};

export const get_attributes_by_access_code = async (
  access_code,
  dialed_number,
  engagement_id,
  options = {}
) => {
  let response = await axiosInstance.get(
    import.meta.env.VITE_API_URL + "/get-attributes-by-access-code",
    {
      params: {
        access_code: access_code,
        dialed_number: dialed_number,
        engagement_id: engagement_id,
      },
      headers: {
        "X-Zoom-User-Id": sessionStorage.getItem("z_user_id"),
      },
      signal: options.signal,
    }
  );
  return response.data;
};

export const get_interpreters_by_language = async (language) => {
  let response = await axiosInstance.get(
    import.meta.env.VITE_API_URL + "/get-interpreters-by-language",
    {
      params: {
        language: language,
      },
      headers: {
        "X-Zoom-User-Id": sessionStorage.getItem("z_user_id"),
      },
    }
  );
  return response.data;
};

export const submit_call_attributes = async (
  data,
  engagement_id,
  access_code,
  category_code_name,
  category_code_value,
  language
) => {
  // Create FormData object
  let FORM_DATA = new FormData();

  // Format attributes as expected by the backend
  const formattedAttributes = [];

  // Process the attrs object if it exists
  if (data.attrs) {
    // Convert attrs object to array of attribute objects with engagement_id
    Object.entries(data.attrs).forEach(([key, value]) => {
      // Skip null or undefined values
      if (value !== null && value !== undefined) {
        formattedAttributes.push({
          attribute_Id: key, // Keep the original attribute_id as a string
          attribute_value: value || "", // Use attribute_value instead of value
          engagement_id: engagement_id,
        });
      }
    });
  }

  // Append the formatted attributes as JSON string
  FORM_DATA.append("attributes", JSON.stringify(formattedAttributes));
  FORM_DATA.append("engagement_id", engagement_id);
  FORM_DATA.append("access_code", access_code);
  FORM_DATA.append("category_code_name", category_code_name);
  FORM_DATA.append("category_code_value", category_code_value);
  FORM_DATA.append("language", language);
  // console.log("Sending attributes:", formattedAttributes);

  let response = await postWithCallLogRetry(
    import.meta.env.VITE_API_URL + "/submit-call-attributes",
    FORM_DATA,
    {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        "Content-Type": "multipart/form-data",
        "X-Zoom-User-Id": sessionStorage.getItem("z_user_id"),
      },
    }
  );
  return response.data;
};
export const interpreter_store_attributes = async (
  data,
  engagement_id,
  category_code_name,
  category_code_value,
  language
) => {
  // Create FormData object
  let FORM_DATA = new FormData();

  // Format attributes as expected by the backend
  const formattedAttributes = [];

  // Process the attrs object if it exists
  if (data.attrs) {
    // Convert attrs object to array of attribute objects with engagement_id
    Object.entries(data.attrs).forEach(([key, value]) => {
      // Skip null or undefined values
      if (value !== null && value !== undefined) {
        formattedAttributes.push({
          attribute_Id: key, // Keep the original attribute_id as a string
          attribute_value: value || "", // Use attribute_value instead of value
          engagement_id: engagement_id,
        });
      }
    });
  }

  // Append the formatted attributes as JSON string
  FORM_DATA.append("attributes", JSON.stringify(formattedAttributes));
  FORM_DATA.append("engagement_id", engagement_id);
  FORM_DATA.append("category_code_name", category_code_name);
  FORM_DATA.append("category_code_value", category_code_value);
  FORM_DATA.append("language", language);
  // console.log("Sending attributes:", formattedAttributes);

  let response = await postWithCallLogRetry(
    import.meta.env.VITE_API_URL + "/interpreter-store-attributes",
    FORM_DATA,
    {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        "Content-Type": "multipart/form-data",
        "X-Zoom-User-Id": sessionStorage.getItem("z_user_id"),
      },
    }
  );
  return response.data;
};
